//Give a function to return if a field is required or not rule. The forms are built using antd.
export const validateConfig = {
  isRequired: (fieldName) => [
    {
      validator: (_, value) => {
        if (
          value === undefined ||
          value === null ||
          (typeof value === "string" && value.trim() === "")
        ) {
          return Promise.reject(
            new Error(`Please select ${fieldName}`)
          );
        }
        return Promise.resolve();
      },
    },
  ],
};

